import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { Component, inject, ViewChild, OnInit, AfterViewInit, EventEmitter, Output } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { reportPopupConstants } from '../../common/experiment-constants';
import { LabTestRepeat, LabTestWithSampleDetails } from '../../models/labTestRepeat';
import { environment } from '../../../environments/environment';
import { GenerateReportPopupData, GenerateReportPopupService, GenerateReportSelectionPayload } from '../../services/generate-report-popup.service';
import { MaterialDesignModule } from '../../common/material-design/material-design.module';

/**
 * @title Table with selection
 */

@Component({
    selector: 'app-generate-report-popup',
    templateUrl: './generate-report-popup.component.html',
    styleUrl: './generate-report-popup.component.scss',
    standalone: true,
    imports: [
    FormsModule,
    MaterialDesignModule,
    MatCheckboxModule,
    DragDropModule
]
})
export class GenerateReportPopupComponent implements OnInit, AfterViewInit {
  private toastr = inject(ToastrService);
  private generateReportPopupService = inject(GenerateReportPopupService);

  ELEMENT_DATA: LabTestWithSampleDetails[] = [];
  readonly dialogRef = inject(MatDialogRef<GenerateReportPopupComponent>);
  displayedColumns: string[] = [reportPopupConstants.select, reportPopupConstants.experimentName, reportPopupConstants.experimentSequenceNo];
  dataSource!: MatTableDataSource<LabTestWithSampleDetails, MatPaginator>
  selection!: SelectionModel<LabTestWithSampleDetails>;
  readonly data = inject<GenerateReportPopupData>(MAT_DIALOG_DATA);
  pageEvent: PageEvent = {
    pageIndex: environment.paginatorDefaults.pageIndex,
    pageSize: environment.paginatorDefaults.pageSize,
    length: environment.paginatorDefaults.length
  };
  pageSizeOptions = environment.pageSizeOptions;
  pageNumber: number = environment.paginatorDefaults.pageNumber;
  pageSize: number = environment.paginatorDefaults.pageSize;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('experimentTable', { static: true }) experimentTable!: MatTable<unknown>;
  dragDisabled = true;
  pdfSelected = false;
  excelSelected = false;
  projectID!: number;
  @Output() previewEvent = new EventEmitter<GenerateReportSelectionPayload>();
  ngOnInit() {
    this.generateReportPopupService.ResetSelectionState();
    this.ELEMENT_DATA = this.data.groupedData;
    this.projectID = this.data.projectID;
    this.dataSource = this.generateReportPopupService.CreateDataSource(this.ELEMENT_DATA);
    this.selection = new SelectionModel(true, this.ELEMENT_DATA);
  }

  ngAfterViewInit() {
    this.generateReportPopupService.AttachPaginator(this.dataSource, this.paginator);
  }

  // Generate Report for Selected Experiments
  SelectedExperiments(preview:boolean) {
    let pdfSelectedTemp=this.pdfSelected;
    if(preview==true){
      pdfSelectedTemp=true;
    }
    const result = this.generateReportPopupService.BuildSelectionResult(
      this.data.groupedData,
      pdfSelectedTemp,
      this.excelSelected,
      this.projectID,
    );

    if (result.errorMessage) {
      this.toastr.error(result.errorMessage);
      return;
    }
    if(result.payload){
    result.payload.preview=preview;
    }
  
    if (preview) {
      this.previewEvent.emit(result.payload);
    } else {
      this.dialogRef.close(result.payload);
    }

  }

  Drop(event: CdkDragDrop<LabTestRepeat[]>) {
    this.dragDisabled = true;
    this.generateReportPopupService.Drop(this.dataSource, this.paginator, event);
  }

  GetSelection(labTestId: number): SelectionModel<LabTestRepeat> {
    return this.generateReportPopupService.GetSelection(labTestId);
  }

  IsAllSelected(labTest: LabTestWithSampleDetails): boolean {
    return this.generateReportPopupService.IsAllSelected(labTest);
  }

  MasterToggle(labTest: LabTestWithSampleDetails): void {
    this.generateReportPopupService.MasterToggle(labTest);
  }

  ToggleRow(labTest: LabTestWithSampleDetails, row: LabTestRepeat): void {
    this.generateReportPopupService.ToggleRow(labTest.labTestId, row);
  }

  SelectAll() {
    this.pdfSelected = true;
    this.excelSelected = true;
  }

  ClearAll() {
    this.pdfSelected = false;
    this.excelSelected = false;
  }

}